// extracted by mini-css-extract-plugin
export default {"description":"style_description__TYbc6","fade-in":"style_fade-in__XZVun","top":"style_top__SNyIn","image":"style_image__GrYDA"};